module.exports = __webpack_public_path__ + "static/media/icons_Agence EBP Bilan Epaule.768ae516.svg";